import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const ContractContentSelector = getSimpleDataSelector((state: RootState) => state.content.contracts);
